import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestNavFooter, {
  NavFooterProps,
} from 'ext-ui/design-system/generated/latest/components/NavFooter/NavFooter'
import GeneratedLiveNavFooter from 'ext-ui/design-system/generated/live/components/NavFooter/NavFooter'
import React, { ReactElement } from 'react'

function renderDesignSystemNavFooter(
  Component: typeof GeneratedLiveNavFooter,
  channel: 'live' | 'latest',
  props: NavFooterProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveNavFooter(props: NavFooterProps): ReactElement {
  return renderDesignSystemNavFooter(GeneratedLiveNavFooter, 'live', props)
}

function LatestNavFooter(props: NavFooterProps): ReactElement {
  return renderDesignSystemNavFooter(GeneratedLatestNavFooter, 'latest', props)
}

function NavFooter(props: NavFooterProps): ReactElement {
  const ResolvedNavFooter = useResolvedDesignSystemComponent(
    LiveNavFooter,
    LatestNavFooter,
  )

  return <ResolvedNavFooter {...props} />
}

export default NavFooter
export type { NavFooterProps }
